// Angular
import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { ISectorAir, ISectorStay, ITicket, ITraveller } from "libraries/service/resources/booking/interfaces/IGetBookings";
import { BookingTravellerDetailComponent } from "libraries/component/booking-information/components/booking-traveller-card/components/booking-traveller/components/booking-traveller-detail/booking-traveller-detail.component";
import { FormGroup } from "@angular/forms";

// Afidium

@Component({
    selector: 'booking-traveller',
    template: `
        <div class="traveller">
            <booking-traveller-abstract
                    [traveller]="traveller"
                    [ageDate]="ageDate"></booking-traveller-abstract>

            <div class="traveller-content">
                <booking-traveller-detail #bookingTravellerDetailComponent
                                          *ngIf="view === 'travellers'"
                                          [traveller]="traveller"
                                          [travellerFormGroup]="travellerFormGroup"
                                          [isEditable]="isEditable"
                                          (onFormPristineChange)="onFormPristineChange.emit()" ></booking-traveller-detail>
                <booking-contacts-contact *ngIf="view === 'contacts'"
                                          [traveller]="traveller"
                                          [showTravellerNames]="false"></booking-contacts-contact>
                <booking-traveller-ticket *ngIf="view === 'tickets'"
                                          [host]="host"
                                          [ticket]="ticket"
                                          [sector]="sector"></booking-traveller-ticket>
            </div>
        </div>
    `,
    styles: [`
        .traveller {
            display: flex;
        }

        booking-traveller-abstract {
            background-color: #fefefe;
            width: 225px;
            border-bottom: 1px solid rgba(189, 195, 199, 0.2);
            border-right: 1px solid rgba(189, 195, 199, 0.2);
        }

        .traveller-content {
            flex: 1;
            border-bottom: 1px solid rgba(189, 195, 199, 0.2);
            border-right: 1px solid rgba(189, 195, 199, 0.2);
        }
    `]
})

export class BookingTravellerComponent {

    @ViewChild('bookingTravellerDetailComponent')
    public bookingTravellerDetailComponent: BookingTravellerDetailComponent;

    @Input()
    public host: string;
    @Input()
    public traveller: ITraveller;
    @Input()
    public ticket: ITicket[];
    @Input()
    public sector: Array<ISectorAir | ISectorStay>;
    @Input()
    public ageDate: string;
    @Input()
    public showDetails: boolean = false;
    @Input()
    public view: string = 'travellers';
    @Input()
    public isEditable: boolean;
    @Input()
    public travellerFormGroup: FormGroup;

    @Output()
    public readonly onFormPristineChange: EventEmitter<void> = new EventEmitter();

    public getTraveller(): ITraveller {
        return this.bookingTravellerDetailComponent.getUpdatedTraveller();
    }

    public onParentCancel(): void {
        this.bookingTravellerDetailComponent.onParentCancel();
    }

    public onParentFormCheck(): void {
        this.bookingTravellerDetailComponent.onParentFormCheck();
    }
}
